export const SET_STORM_POOL = 'SET_STORM_POOL';
export const SET_STORM_SESSION = 'SET_STORM_SESSION';
export const SET_ALL_USERS = 'SET_ALL_USERS';
export const SET_CHOSEN_USER = 'SET_CHOSEN_USER';
export const UPDATE_CHOSEN_USER = 'UPDATE_CHOSEN_USER';
export const SET_STORM_USER = 'SET_STORM_USER';
export const SET_USER_EVENTS = 'SET_USER_EVENTS';
export const SET_EVENT_USER = 'SET_EVENT_USER';
export const REMOVE_STORM_USER = 'REMOVE_STORM_USER';
export const SET_ALL_STORM_USERS = 'SET_ALL_STORM_USERS';
export const REMOVE_INTERNAL_USER = 'REMOVE_INTERNAL_USER';
export const ADD_STORM_USER = 'ADD_STORM_USER';
export const SET_ALL_TICKETS = 'SET_ALL_TICKETS';



// WEBPACK FOOTER //
// ./src/storm/store/mutation-types.js